import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Menu from "../../components/menu";
import NavigationMenu from "../../components/navigationMenu";
import Header from "../../components/header";
import { Row, Col } from "antd";
import { useGlobalDispatch, useGlobalState } from "../../context/Provider";
import { getWarehosuerList } from "../../context/warehouse/warehouse.action";
import { GetWarehouseList } from "../../api/warehouse";

const Panel = () => {
  const [menuVisible, setMenuVisible] = useState(false);

  const { warehouserListDispatch: dispatch }: any = useGlobalDispatch();
  const { warehouserList }: any = useGlobalState();

  const handleGetWarehouseList = () => {
    if (warehouserList.data.length) {
      dispatch(getWarehosuerList({ list: warehouserList.data }));
    } else {
      GetWarehouseList().then((res: any) => {
        if (res.status === 200) {
          dispatch(getWarehosuerList({ list: res.data.items }));
        }
      });
    }
  };

  useEffect(() => {
    handleGetWarehouseList();
  }, []);

  return (
    <Row>
      <Col xs={0} md={4}>
        <Menu setVisible={setMenuVisible} />
      </Col>
      <Col xs={4} md={0}>
        <NavigationMenu visible={menuVisible} setVisible={setMenuVisible}>
          <Menu isDark={true} isMobile={true} setVisible={setMenuVisible} />
        </NavigationMenu>
      </Col>
      <Col xs={24} md={20}>
        <Header setVisible={setMenuVisible} />
        <Outlet />
      </Col>
    </Row>
  );
};

export default Panel;
